module.exports = __webpack_public_path__ + "static/media/desktopScreenshot09.90ebe438.jpg";